<template>
  <v-container>
    <div class="d-flex flex-column align-center mt-4 mb-4 text-center">
      <h2>Wunschdienstplan</h2>
    </div>
    
    <v-list>
      <v-list-item v-for="wishPeriod in sortedWishPeriods" :key="wishPeriod.id">
        <div :class="[
        !wishPeriod.locked ?  '' : 'transparent',
        'gradient',
        'shadow',
        'round-corners',
        'responsive',
        clickedItem === wishPeriod.id ? 'click-animation' : '']"
           @click="navigateToWunschdienst(wishPeriod)">
        <v-row >
          <v-col>
            <div class="pa-0 ma-0 text-subtitle-1">
              {{ wishPeriod.title }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pa-0 ma-0 text-subtitle-2">
            <div>
              Periode: 
              <b>{{ wishPeriod?.startDate.toDate().toLocaleDateString('de-DE') }}</b>
              bis <b>{{ wishPeriod?.endDate.toDate().toLocaleDateString('de-DE') }}</b><br>
            </div>
          </v-col>
        </v-row>
          <v-row>
            <v-col class="pa-0 ma-0 text-subtitle-2">
              <div>
                Deadline: <b>{{ wishPeriod?.deadline.toDate().toLocaleDateString('de-DE') }}</b>
              </div>
            </v-col>
          </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <small v-if="!wishPeriod.locked">Wunschdienst erfassen</small>
            <small v-else>Wunschdienst ansehen</small>
          </v-col>
        </v-row>
        </div>
      </v-list-item>
    </v-list>

    <v-container class="text-center" v-if="wishCount === 0">
      <small>Keine Wunschdienst Zeiträume gefunden!</small>
    </v-container>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import router from "@/router";

import { useCollection, useFirestore } from 'vuefire'
import { collection } from 'firebase/firestore'

export default defineComponent({
  setup() {
    const db = useFirestore();
    const wishPeriods = useCollection(collection(db, 'wishPeriods'));
    
    const sortedWishPeriods = computed(() => {
      return wishPeriods.value.slice().sort((a, b) => b.endDate.toDate() - a.endDate.toDate()).filter(period => period.hidden === false);
    });
    
    const wishCount = computed(() => {
      return sortedWishPeriods.value.filter(period => period.hidden === false).length;
    });
    const clickedItem = ref<number | null>(null);
    
    const navigateToWunschdienst = (item: any) => {
      clickedItem.value = item.id;
      setTimeout(() => {
        clickedItem.value = null;
      }, 300); // Duration of the animation
      router.push(`/wunschdienst/${item.id}`);
    };
    
    return { sortedWishPeriods,  clickedItem, navigateToWunschdienst, wishCount };
  },
});

</script>

<style scoped>
.wrap-text {
  word-wrap: break-word;
}

.gradient {
  color: var(--new-primary-weiß);
  background-image: linear-gradient(90deg,
  rgba(0, 75, 160, 1) 0%,
  rgba(37, 31, 117, 1) 100%);
}

.round-corners {
  border-radius: 5px;
}

.shadow {
  box-shadow: 0 0 20px rgba(34, 38, 47, 0.1);
}


.transparent {
  background-image: linear-gradient(90deg,
  rgba(0, 75, 160, 0.6) 0%,
  rgba(37, 31, 117, 0.8) 100%);
}

.responsive {
  padding: var(--new-responsive-space);
}

.click-animation {
  animation: clickEffect 0.3s ease;
}

@keyframes clickEffect {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.80);
  }
  100% {
    transform: scale(1);
  }
}
</style>